import {Switch} from 'react-router-dom';

import {ROUTE_CONFIG} from 'utils/route-config';
import {PrivateRoute, RedirectToPrivateRoute} from 'utils/routes';

import {Conversations} from './Conversations';
import {Sessions} from './OnlineSessions';

export const Online: React.FC = () => (
    <Switch>
        <PrivateRoute {...ROUTE_CONFIG.ONLINE_SESSIONS.SESSIONS} component={Sessions} />
        <PrivateRoute {...ROUTE_CONFIG.ONLINE_SESSIONS.CONVERSATIONS} component={Conversations} />

        <RedirectToPrivateRoute
            routes={[
                ROUTE_CONFIG.ONLINE_SESSIONS.SESSIONS,
                ROUTE_CONFIG.ONLINE_SESSIONS.CONVERSATIONS
            ]}
        />
    </Switch>
);
